import { BandChart, MultiLineChart, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${MultiLineChart.Styled.Plot} {
    height: 300px;
  }
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendItemVector = styled.div`
  height: 0;
  width: 16px;
  border-top: 1px solid var(--border-default);
`;

export const LegendItemLabel = styled.span`
  ${typographyV2.bodyBase};
`;

export const ChartAndHorizonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const BandChartWrapper = styled.div<{ $color: string }>`
  & svg {
    height: 240px;
  }

  ${BandChart.Styled.LinePlot} {
    color: ${({ $color }) => $color};
    stroke-width: 1px;
  }
`;
